import React from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function Airports() {
  return (
    <div>
    <SideBar></SideBar>
    <TopBaner></TopBaner>
    <div className='airportsDiv' style={{ display: 'flex', flexWrap: 'wrap' }}>
  <div className='invitationCard'>
    <h3>קישנב</h3>
    <img className='airportsImg' src="Chisinau.jpg" alt="Chisinau" />
  </div>
  <div className='invitationCard'>
    <h3>יאשי</h3>
    <img className='airportsImg' src="Iasi.jpg" alt="Chisinau" />
  </div>
  <div className='invitationCard'>
    <h3>בודפשט</h3>
    <img className='airportsImg' src="Budapest.jpg" alt="Chisinau" />
  </div>
  <div className='invitationCard'>
    <h3>בוקרשט</h3>
    <img className='airportsImg' src="Bucharest.jpg" alt="Chisinau" />
  </div>
</div>
    <Footer></Footer>
    </div>
  )
}

export default Airports